module.exports = __webpack_public_path__ + "assets/images/XCD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/XCD100.png
// module id = 1476
// module chunks = 1